(function () {
  'use strict';

  angular.module('ringbaPortal').component('tcpaShieldFileUpload', {
    bindings: {
    },
    controller: TcpaShieldFileUploadController,
    controllerAs: 'vm',
    templateUrl: '/scripts/components/tcpa-shield/tcpa-shield-file-upload.view.html'
  });

  function TcpaShieldFileUploadController(
    accountsService,
    utils,
    billingService,
    tcpaShieldService,
    toaster,
    bsLoadingOverlayService,
    $translate
  ) {
    'ngInject';

    const vm = this;

    vm.$onInit = onInit;

    vm.currentAccountId = accountsService.currentAccountId;
    vm.uploadFile = uploadFile;
    vm.choseFile = choseFile;

    vm.tagUploadLoader = 'tagUploadLoader';

    function onInit() {
      loadBillingPlans();
    }

    function loadBillingPlans() {
      return billingService.getTCPABillingInfo(vm.currentAccountId)
        .then(function (plan) {
          vm.plan = plan;
        })
        .catch(utils.errorHandler);
    }

    function choseFile(file, invalidFile) {
      if (file) {
        vm.file = file;
      } else if (invalidFile && invalidFile.length != 0) {
        vm.file = null;
        toaster.pop('error', $translate.instant('TCPA_SHIELD_BULK_UPLOAD_FILE_TOO_LARGE'));
      }
    }

    function uploadFile() {
      if (vm.file) {
        _showUploadLoader(true);
        return tcpaShieldService.uploadFile(vm.currentAccountId,vm.file).then(function () {
          toaster.pop('success', $translate.instant('TCPA_SHIELD_BULK_UPLOAD_SUCCESS'));

        }).catch(utils.errorHandler)
          .finally(function () {
            _showUploadLoader(false);
          });
      }
    }

    function _showUploadLoader(show) {
      vm.uploadingNumbersList = show;
      _makeLoaderVisible(show, vm.tagUploadLoader);
    }

    function _makeLoaderVisible(visible, loaderRef) {
      if (visible) {
        bsLoadingOverlayService.start({
          referenceId: loaderRef
        });
      } else {
        bsLoadingOverlayService.stop({
          referenceId: loaderRef
        });
      }
    }

  }


})();
